import React, { useRef, useState } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ConfirmModal } from 'components';

interface UploadedProps {
  fileName: string | null;
  fileType: string | null;
  onFileSelect: (file: File) => void;
  onDelete: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  isConfirmModalOpen: boolean;
  setConfirmModalOpen: (open: boolean) => void;
  modalTitle: string;
  modalSubtitle: string;
  subTitle: string;
}

const UploadedFiles: React.FC<UploadedProps> = ({
  fileName,
  fileType,
  onFileSelect,
  onDelete,
  onConfirm,
  isLoading,
  isConfirmModalOpen,
  setConfirmModalOpen,
  modalTitle,
  modalSubtitle,
  subTitle,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [filePreview, setFilePreview] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setFilePreview(fileURL);
      onFileSelect(file);

      // Reset the input value so the user can re-upload the same file
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // This resets the file input
      }
    }
  };

  return (
    <>
      {!fileName ? (
        <Box sx={styleSheet.mainContainer}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <>
              <CloudUploadIcon sx={{ fontSize: 40, color: '#666' }} />
              <Typography variant="body1" sx={{ marginTop: 1 }}>
                Drag & Drop or choose files to upload
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', marginTop: 1 }}>
                {subTitle}
              </Typography>
              <Button
                variant="contained"
                sx={{
                  marginTop: 2,
                  backgroundColor: '#233F91',
                  color: '#fff',
                  borderRadius: '15px',
                  width: '215px',
                  height: '57px',
                  mt: 2,
                }}
                onClick={() => fileInputRef.current?.click()}
              >
                Browse File
              </Button>
              <input
                type="file"
                accept="image/*,video/*,application/pdf"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </>
          )}


        </Box>
      ) : null}

      <ConfirmModal
        title={modalTitle}
        subtitle={modalSubtitle}
        cancelText="Cancel"
        confirmText="Confirm"
        titleColor="#020303"
        isLoading={false}
        onCancel={() => setConfirmModalOpen(false)}
        onConfirm={onConfirm}
        isConfirmModal={isConfirmModalOpen}
        warning="Warning"
      />
    </>
  );
};

export default UploadedFiles;

const styleSheet = {
  mainContainer: {
    border: '2px dashed #ccc',
    width: { xs: '295px', md: '563px' },
    height: '276px',
    borderRadius: '8px',
    padding: '16px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: '#f9f9f9',
  },
};
